export default "__VITE_ASSET__DV4WR$P6__"